var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-outlined-button',{attrs:{"text":_vm.text,"color":"primary","icon":"mdi-check","disabled":_vm.disabled,"loading":_vm.loading,"toolbar":_vm.toolbar,"small":_vm.small},on:{"onButtonClick":_vm.onButtonClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }